// Noms d'articles traduits pour le catalogue des cartes et le panier (lot A).
// - prettyTitle : titre lisible tiré du nom de fichier d'un visuel (« noel-rouge-enfantin.jpg » → « Noël rouge enfantin »).
//   C'est le texte FRANÇAIS ; les autres langues le remplacent par `visual-catalog.visuals.<nom-du-fichier>`.
// - useVisualTitle : renvoie visuel → titre dans la langue courante (repli : le français).
// - useCartItemName : renvoie article du panier → nom à afficher dans la langue courante. Le nom ENREGISTRÉ dans
//   l'article (et envoyé au serveur) reste le français ; seul l'affichage change.
import { useT, useLang, DEFAULT_LANG } from '../i18n';
import { useProductTexts } from './productI18n';

const WORD_FIXES = { noel: 'Noël', paques: 'Pâques', bebe: 'Bébé', feuillor: "Feuilles d'or", aqua: 'aquarelle' };

export function prettyTitle(visuel) {
  const words = String(visuel || '').replace(/\.[^.]+$/, '').split(/[-_]+/).filter(Boolean);
  const fixed = words.map((w) => WORD_FIXES[w.toLowerCase()] || w.toLowerCase());
  const s = fixed.join(' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
}

const stem = (visuel) => String(visuel || '').replace(/\.[^.]+$/, '').toLowerCase();

export const useVisualTitle = () => {
  const t = useT('visual-catalog');
  return (visuel) => t.or(`visual-catalog.visuals.${stem(visuel)}`, prettyTitle(visuel));
};

export const useCartItemName = () => {
  const { lang } = useLang();
  const t = useT('visual-catalog');
  const tp = useProductTexts();
  return (item) => {
    if (lang === DEFAULT_LANG) return item.name;
    // Fiche produit : adresse enregistrée à l'ajout (ProductDetail) → titre traduit.
    if (item.url) return tp({ url: item.url, titre: item.name }).titre;
    // Carte choisie dans le catalogue des visuels (VisualCatalogPage) : « Carte à gratter – <visuel> ».
    if (item.visuelSku && String(item.id).startsWith('visual-')) {
      const title = t.or(`visual-catalog.visuals.${stem(item.visuelSku)}`, null); // null : visuel pas encore traduit
      return title ? t('visual-catalog.cartName', { name: title }) : item.name;
    }
    return item.name;
  };
};
